import { cva } from 'class-variance-authority'
import React, { LabelHTMLAttributes } from 'react'

import { cn } from '@frame/lib/utils/cn'

const variants = cva(
  [
    'pointer-events-none',
    '-translate-y-4',
    'absolute',
    'bg-white',
    'duration-300',
    'font-medium',
    'left-[20px]',
    'origin-[0]',
    'px-1',
    'text-moss-700',
    'text-xs',
    'top-[3px]',
    'transition-all',
    'z-10',
    'after:font-semibold',
    'after:text-base',
    'peer-disabled:text-moss-500',
    'peer-focus:-translate-y-4',
    'peer-focus:bg-white',
    'peer-focus:font-medium',
    'peer-focus:px-1',
    'peer-focus:rounded-[2px]',
    'peer-focus:text-electric-650',
    'peer-focus:text-xs',
    'peer-focus:top-[3px]',
    'peer-placeholder-shown:-translate-y-1/2',
    'peer-placeholder-shown:bg-transparent',
    'peer-placeholder-shown:font-normal',
    'peer-placeholder-shown:px-0',
    'peer-placeholder-shown:text-sm',
    'peer-placeholder-shown:top-1/2',
  ],
  {
    variants: {
      showError: {
        true: [
          'peer-placeholder-shown:-translate-y-4',
          'peer-placeholder-shown:bg-white',
          'peer-placeholder-shown:font-medium',
          'peer-placeholder-shown:px-1',
          'peer-placeholder-shown:rounded-[2px]',
          'peer-placeholder-shown:text-error-600',
          'peer-placeholder-shown:text-xs',
          'peer-placeholder-shown:top-[3px]',
          'text-error-600',
        ],
      },
      showWarning: {
        true: [
          'peer-placeholder-shown:-translate-y-4',
          'peer-placeholder-shown:bg-white',
          'peer-placeholder-shown:font-medium',
          'peer-placeholder-shown:px-1',
          'peer-placeholder-shown:rounded-[2px]',
          'peer-placeholder-shown:text-warning-600',
          'peer-placeholder-shown:text-xs',
          'peer-placeholder-shown:top-[3px]',
          'text-warning-600',
        ],
      },
      applyCobranding: {
        true: ['peer-focus:text-cobranding-hover-dark'],
      },
    },
    defaultVariants: {
      showError: false,
      showWarning: false,
      applyCobranding: true,
    },
  }
)

type Props = {
  label: string
  labelTag?: React.ReactNode
  showError?: boolean
  showWarning?: boolean
  applyCobranding: boolean
} & LabelHTMLAttributes<HTMLLabelElement>

export function Label({ label, labelTag, showError, showWarning, applyCobranding, ...props }: Props) {
  return (
    <label className={cn(variants({ showError, showWarning, applyCobranding }))} {...props}>
      {label}
      {labelTag}
    </label>
  )
}
